import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTranslation } from '../hooks/useTranslation';

export default function AGBPageRU() {
  const { currentLanguage } = useTranslation();
  
  // Отладочная информация
  console.log('AGBPageRU - currentLanguage:', currentLanguage);
  
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <div className="min-h-screen bg-white text-dark-900">
      <Header />
      <main className="pt-16 sm:pt-20">
        <motion.section
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="py-8 sm:py-16 lg:py-20"
        >
          <div className="max-w-4xl mx-auto px-3 sm:px-4 lg:px-8">
            <motion.div variants={item} className="text-center mb-8 sm:mb-12">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 text-dark-900">
                Общие условия и положения
              </h1>
              <p className="text-sm sm:text-base text-gray-600">
                Альфира Герман – Alphavita - частная практика для коучинга и гипноза
              </p>
              <p className="text-xs sm:text-sm text-gray-500 mt-2">
                (далее – «Alphavita – Коучинг»)
              </p>
            </motion.div>

            <motion.div variants={item} className="prose prose-sm sm:prose-lg max-w-none">
              <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">1. Сфера применения</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Настоящие Общие условия и положения (AGB) регулируют договорные отношения между Альфирой Герман (Alphavita – Коучинг) и ее клиентами в отношении всех услуг по коучингу, тренингам и консультированию.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Отклоняющиеся или противоречащие условия клиента не признаются, если только Альфира Герман (Alphavita – Коучинг) не даст на это явного письменного согласия.
                </p>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Настоящие AGB действуют и в том случае, если Альфира Герман (Alphavita – Коучинг), зная о противоречащих или отклоняющихся условиях клиента, безусловно выполняет договоры.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">2. Предложения и гонорары</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Предложения Alphavita – Коучинг являются необязательными. Изменения, в частности в отношении услуг и цен, остаются за нами.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Гонорары за услуги коучинга, действующие на данный момент, указаны на веб-сайте или в индивидуальном договоре на коучинг.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Если не оговорено иное, все гонорары указаны в евро (€). Согласно § 19 Закона о налоге с оборота (UStG), налог с оборота не начисляется.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.4</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Расходы на проезд, проживание, телефонные разговоры и любые другие дополнительные расходы, возникающие в связи с оказанием услуг, оплачиваются клиентом отдельно.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">2.5</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Гонорар, если не оговорено иное, оплачивается либо банковским переводом до каждой сессии, либо наличными после каждой сессии. За онлайн- и телефонные сессии гонорар оплачивается заранее банковским переводом. Клиент оплачивает телефонные расходы за телефонную сессию.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">3. Форс-мажор и другие препятствия к оказанию услуг</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">3.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  В случае форс-мажора Alphavita – Коучинг имеет право перенести согласованные даты коучинга. Форс-мажор также включает препятствия к оказанию услуг, возникшие из-за болезни, несчастного случая или аналогичных непредвиденных обстоятельств.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">3.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  В таких случаях клиент будет незамедлительно проинформирован Alphavita – Коучинг, и будет предложена альтернативная дата. Право на возмещение расходов на проезд или других затрат отсутствует.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">4. Право отказа от договора для потребителей</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">4.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Если клиент является потребителем, он имеет право отказаться от данного договора в течение четырнадцати дней без указания причин. Срок отказа составляет четырнадцать дней со дня заключения договора.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">4.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Для осуществления права отказа клиент должен уведомить нас (Альфира Герман, Hochburger Str. 32, 79312 Emmendingen, E-Mail: alphavita@gmx.de) о своем решении посредством однозначного заявления (например, письмом, отправленным по почте, или по электронной почте).
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">4.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Для соблюдения срока отказа достаточно отправить уведомление об осуществлении права отказа до истечения срока.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">4.4</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Исключение или прекращение права отказа: Право отказа от договора на оказание услуг прекращается, если услуга была полностью оказана и ее выполнение было начато только после того, как клиент дал на это свое явное согласие и одновременно подтвердил, что ему известно о потере своего права на отказ при полном выполнении договора с нашей стороны.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">5. Авторское право</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">5.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Все материалы, выданные клиенту, концепции, скрипты и презентационные материалы являются интеллектуальной собственностью Альфиры Герман (Alphavita – Коучинг).
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">5.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Эти материалы предназначены исключительно для личного пользования клиента. Полное или частичное воспроизведение, передача третьим лицам или коммерческое использование без письменного согласия Альфиры Герман не допускается. Публикация, даже частичная, запрещена и может повлечь за собой судебное преследование.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">6. Страхование и личная ответственность</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">6.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  В случае семинаров, мастер-классов или командного коучинга, которые проводятся вне помещений Alphavita – Коучинг, организатором всегда является заказчик. В связи с этим участники не имеют страховой защиты через Alphavita – Коучинг.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">6.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Каждый клиент несет полную ответственность за себя и свои действия во время и вне сессий коучинга и сам отвечает за любые причиненные убытки.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">7. Исключение ответственности</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">7.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Деятельность Alphavita – Коучинг является исключительно услугой. В связи с этим успех не может быть гарантирован.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">7.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Все документации, советы и информация, полученные в ходе коучинга и семинаров от Alphavita – Коучинг, тщательно проверены и взвешены. Любая ответственность за ущерб, возникший в результате использования этой информации, исключается.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">7.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Ответственность Alphavita – Коучинг ограничивается грубой халатностью или умыслом.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">8. Конфиденциальность и защита данных</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">8.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Альфира Герман (Alphavita – Коучинг) обязуется соблюдать строгую конфиденциальность в отношении всех рабочих, деловых и личных дел клиента, ставших известными в рамках деятельности, даже после прекращения договора.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">8.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Материалы и записи, предоставленные для целей консультирования, будут храниться с особой тщательностью и защищены от доступа третьих лиц.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">8.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Дополнительная информация о защите данных, в частности о правах клиента согласно Общему регламенту по защите данных (DSGVO), содержится в отдельной Политике конфиденциальности на веб-сайте.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">9. Обязанность клиента к сотрудничеству</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">9.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Сотрудничество основано на взаимном доверии. Коучинг — это добровольный, активный и ответственный процесс, который ведет клиент.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">9.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Клиент осознает, что Alphavita – Коучинг выступает в роли помощника и поддержки в принятии решений и изменениях, но фактическая работа по изменению должна быть выполнена самим клиентом.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">9.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Условием успешного сотрудничества является открытость клиента и готовность разобраться в своей ситуации.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">10. Разграничение с психотерапией и целительством</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">10.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Коучинг не является терапией и не заменяет ее. Деятельность Alphavita – Коучинг четко отличается от роли врача, психолога или целителя.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">10.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Диагнозы не ставятся, и обещания исцеления не даются.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">10.3</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Коучинг у Alphavita – Коучинг предполагает нормальную психологическую и физическую выносливость клиента. С согласием на сотрудничество клиент подтверждает свою способность к саморефлексии и дееспособность.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">10.4</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Клиент обязан информировать Alphavita – Коучинг о возможных предварительных диагнозах или текущих психотерапевтических процедурах.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">11. Заключительные положения</h2>
                
                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">11.1</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3 sm:mb-4">
                  Если отдельные положения договора с клиентом, включая эти Общие условия и положения, окажутся полностью или частично недействительными, это не повлияет на действительность остальных положений. Вместо недействительного положения применяются соответствующие законные нормы.
                </p>

                <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-dark-900">11.2</h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Местом исполнения является Эммендинген. Местом для всех споров по данному договору является районный суд в Эммендингене. Применяется право Федеративной Республики Германия.
                </p>
              </div>

              <div className="bg-rose-50 border border-rose-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8">
                <p className="text-sm sm:text-base text-gray-600 text-center">
                  <strong>Эммендинген, 22.09.2025</strong>
                </p>
              </div>
            </motion.div>
          </div>
        </motion.section>
      </main>
      <Footer />
    </div>
  );
}
